import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "sf-divider",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "none",
  viewBox: "0 0 10 10"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("line", {
  class: "sf-divider__line sf-divider__line--horizontal",
  x1: "0%",
  x2: "100%",
  y1: "50%",
  y2: "50%",
  "stroke-linecap": "round",
  "vector-effect": "non-scaling-stroke"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("line", {
  class: "sf-divider__line sf-divider__line--vertical",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%",
  "stroke-linecap": "round",
  "vector-effect": "non-scaling-stroke"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Divider',
  setup(__props) {

/**
 * This is a divider element that can be configured to be displayed horizontally or vertically.
 *
 * It's made to be configured through CSS, rather than through props, because then we can change
 * its styles dynamically through media queries, for example.
 *
 * To toggle its direction between horizontal and vertical, use the
 * `divider-orientation($direction: horizontal | vertical)` mixin.
 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
}

})